import { connect } from 'react-redux'
import { compose, withHandlers, withProps, withState } from 'recompose'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import * as eventActions from 'app/modules/integrations/actions.js'

import BusinessExportModal from './component'


const makeExportConfig = (sourceId, startDate, endDate) => {
  const start = moment(startDate).startOf("day")
  const end = moment(endDate).endOf("day")
  const offset = start.unix() - end.unix()
  const recentTime = end.unix() * 1000
  const timezoneMinutesOffsetFromGMT = moment().utcOffset() 

  return ({ sourceId: sourceId, start: recentTime, offset: offset, chronoUnit:"seconds", timezone: timezoneMinutesOffsetFromGMT })
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      postBusinessCsvRequest: eventActions.postBusinessEventCsv
    },
    dispatch
  ),
})


export default compose(
  connect(null, mapDispatchToProps),

  withState('focusedInput', 'updateFocusedInput', null),
  withState('timePeriod', 'setTimePeriod', null),
  withState('startDate', 'setStartDate', moment()),
  withState('endDate', 'setEndDate', moment()),

  withHandlers({
    onChangeTimePeriod: ({ setTimePeriod }) => period => {
      setTimePeriod(period)
    },
    onDatePickerFocus: ({ updateFocusedInput }) => type => {
      updateFocusedInput(type)
    },
    onDateChange: props => timePeriod => {
      props.setStartDate(timePeriod.startDate)
      props.setEndDate(timePeriod.endDate)
    },
    
    onClickExportButton: props => () => {
      props.actions.postBusinessCsvRequest(
        {
          ...makeExportConfig(props.sourceId, props.startDate.format('YYYY-MM-DD'), props.endDate.format('YYYY-MM-DD'), props.timePeriod)
        })
          setTimeout(props.onClose, 800)
    },
  }),
  withProps(props => {
    if (!!props.endDate && props.endDate.diff(props.startDate, 'days') < 0) {
      return {
        disabledReason: 'End date must be after start date'
      }
    } 
    return {
      disabledReason: '',
    }
  }),
)(BusinessExportModal)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/BusinessEventExportModal/index.js